var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.overlay)?_c('v-overlay',{attrs:{"value":_vm.loadingDisplay,"z-index":999,"opacity":0.5,"color":"white"}},[_vm._t("default")],2):(_vm.progress)?_c('v-progress-linear',_vm._b({attrs:{"active":_vm.loadingDisplay,"indeterminate":"","absolute":"","color":"light-blue"}},'v-progress-linear',_vm.linearProps,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }